// Lives in a .ts file so Fast Refresh isn't invalidated by mixed exports in the .tsx Provider.
import { useContext } from 'react';
import { ThemeContext } from '@/contexts/themeContextValue';

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
